import React, { useState, useEffect } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import "./Styles.module.scss";



const TotalRevenueChart = ({ data, domain, ticks, strokeWidth, dataKey, strokes,  yaxis,height }) => {


    return (
        // <div className="chart-container">
            <ResponsiveContainer width={"100%"} height={height}>

                <LineChart  data={data}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#aaa" vertical={false} />
                    <XAxis dataKey={dataKey} axisLine={false} tickLine={false} />
                    {yaxis &&
                        <YAxis
                            domain={domain}
                            ticks={ticks}
                            tickFormatter={(value) => `${value}`}
                            axisLine={false}
                            tickLine={false}
                        />
                    }
                    <Tooltip />
                    {strokes.map((stroke, index) => {
                        return (
                            <Line key={index} type="monotone" dataKey={stroke.dataKey} stroke={stroke.color} strokeWidth={strokeWidth} />
                        )
                    })}
                </LineChart>
            </ResponsiveContainer>
    );
};

export default TotalRevenueChart;
